var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapchatSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "snapchat",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M21,17a4.33,4.33,0,0,1-4,2s-1,2-5,2-5-2-5-2a4.33,4.33,0,0,1-4-2,4,4,0,0,0,3.35-1.79,3.18,3.18,0,0,0,.57-1.87c0-.11,0-.21,0-.32a7.53,7.53,0,0,1-2.85-.75A1.9,1.9,0,0,1,3,10.53,2,2,0,0,1,4.12,8.71a2,2,0,0,1,1.75,0,2.8,2.8,0,0,0,.67.23,3.46,3.46,0,0,1,0-.45,5.48,5.48,0,0,1,11,0,3.46,3.46,0,0,1,0,.45,2.8,2.8,0,0,0,.67-.23,2,2,0,0,1,1.75,0A2,2,0,0,1,21,10.53a1.9,1.9,0,0,1-1.06,1.74,7.53,7.53,0,0,1-2.85.75c0,.11,0,.21,0,.32a3.18,3.18,0,0,0,.57,1.87A4,4,0,0,0,21,17Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchatSvgrepoCom);
export default __webpack_public_path__ + "static/media/snapchat-svgrepo-com.1a31ecb3259bca366a6221affa2b3800.svg";
export { ForwardRef as ReactComponent };